$(function () {
    $('.guide-card button').on('click', function (e) {
        $('form').find('input[name="guide"]').val($(this).parents('.guide-card').data('zoho-title'))
        $('#guide-form').addClass('active');
    });
    $('#close-pop-up').on('click', function (e) {
        $('#guide-form').removeClass('active');
    });
});